import {useEffect}  from "react";
import {data1 , data2 , data3 , data4} from '../../data/data-containers/data-Explore2.js';
import {getMainWidth , handelTitle} from '../../utils'


import Breadcrumb from '../../components/Breadcrumb'

import CardNewListed from './CardNewListed'
import CardFilter from './CardFilter'
import CardTopSelling from './CardTopSelling'
import CardIco from'./CardIco'
import './Explore2.css'

/**
 * Explore page container (Style 2).
 *
 * Alternative layout for the explore/landing page.
 * Organizes content into a grid with:
 * - Newly listed items
 * - Filter sidebar
 * - Top selling items
 * - Icon/feature section
 *
 * Uses static data imports from data-Explore2.js for demonstration.
 *
 * @module containers/Explore2
 * @category Containers
 * @returns {React.ReactElement} Rendered explore page (style 2)
 */
const Explore2Container = () => {

  useEffect(() => {
    // document.title = 'Explore2'
    handelTitle('Explore2')
    getMainWidth()
  },[])

  return (
    <>
      <main className="main-content mt-1 border-radius-lg">

        <div className="container-fluid">
          <div className="page-header breadcrumb-header min-height-300 border-radius-xl mt-4 mb-30 Explore2IMG">
            <Breadcrumb text1='Explore Style 2' text2='Explore Style 2'/>
          </div>
          
        </div>
        
        
        <div className="container-fluid">
          <div className="row">
            <CardNewListed data={data1} />

            <div className="col-lg-4">
              
              <CardFilter data3={data3} data4={data4} />

              <CardTopSelling data={data2} />
            </div>
          </div>
        </div>

        <div className="container-fluid">
          
        </div>

        <div className="container-fluid">
          <CardIco />
        </div>

      </main>
    </>
  );
}

export default Explore2Container;

